<template>
  <Modal v-bind="$props" @close="closeUserModal">
    <form class="body" v-if="subscription">
      <h2 class="header">Редактирование подписки</h2>
      <div class="form-item">
        <p class="title">Имя:</p>
        <Chip :color="'white'" small>{{ subscription.name }}</Chip>
      </div>
      <div class="form-item">
        <p class="title">Тип диапазона:</p>
        <Select
          placeholder="Выберите тип диапазона"
          :items="timeRanges"
          v-model="timeRange"
          @input="handleTimeRangeInput"
          :disabled="loading"
        />
      </div>
      <div class="form-item">
        <p class="title">Количество:</p>
        <Input
          type="number"
          v-model.number="timeRangeCount"
          :placeholder="timeRangePlaceholder"
          @input="handleTimeRangeCountInput"
          :disabled="loading"
        />
      </div>
      <div class="form-item">
        <p class="title">Стоимость:</p>
        <Input
          type="number"
          v-model.number="amount"
          :placeholder="'Введите стоимость подписки (USD)'"
          :disabled="loading"
        />
      </div>
      <div class="form-item">
        <p class="title">Продукты:</p>
        <p class="subtitle">
          - Выберите продукты, которые будут включены в данную подписку
        </p>
        <MultiSelect
          :options="productsOptions"
          v-model="selectedProducts"
          :disabled="loading"
        />
      </div>
      <div class="actions">
        <Button
          :loading="loading"
          blue
          :disabled="loading"
          @click.prevent="updateSubscriptionRequest"
          >Сохранить</Button
        >
        <Button gray v-show="!loading">Отмена</Button>
      </div>
    </form>
  </Modal>
</template>

<script>
import { toast } from "vue3-toastify";
// import getProductAlias from "@/utils/getProductAlias";
// import getPaymentAlias from "@/utils/getPaymentAlias";
import { mapActions, mapGetters } from "vuex";

// import {
//   mdiCancel,
//   mdiArrowRight,
//   mdiDelete,
//   mdiGiftOutline,
//   mdiMinusCircle,
//   mdiDataMatrixScan,
//   mdiCalendarClockOutline,
// } from "@mdi/js";
// import copyToClipboard from "@/utils/copyToClipboard";
import Button from "@/components/Button.vue";
// import StatusChip from "@/components/StatusChip.vue";
import Modal from "@/components/Modal.vue";
// import Table from "@/components/Table.vue";
// import SvgIcon from "@jamescoyle/vue-icon";
// import SelectButtons from "@/components/SelectButtons.vue";
import Chip from "@/components/Chip.vue";
// import IconButton from "@/components/IconButton.vue";
import Select from "@/components/Select.vue";
import Input from "@/components/Input.vue";
import MultiSelect from "@/components/MultiSelect.vue";
import getProductAlias from "@/utils/getProductAlias";

export default {
  name: "UpdateSubscriptionDialog",
  components: {
    Modal,
    // StatusChip,
    Button,
    // Table,
    // SvgIcon,
    // SelectButtons,
    Chip,
    // IconButton,
    Select,
    Input,
    MultiSelect,
  },
  props: {
    ...Modal.props,
    subscription: Object,
  },
  data() {
    return {
      timeRanges: [
        { id: "HOUR", name: "Час" },
        { id: "DAY", name: "Сутки" },
        { id: "MONTH", name: "Месяц" },
        { id: "YEAR", name: "Год" },
      ],
      timeRange: null,
      timeRangeCount: 1,
      amount: 1,
      selectedProducts: [],
      loading: false,
    };
  },
  mounted() {
    console.log("m");
    this.fetchProducts();
    this.fetchSubscriptions();
  },
  methods: {
    ...mapActions([
      "fetchProducts",
      "updateSubscription",
      "fetchSubscriptions",
    ]),

    getProductAlias,

    validateForm() {
      console.log(
        !this.timeRange ||
          !this.timeRangeCount ||
          !this.amount ||
          !this.selectedProducts.length
      );
      if (
        !this.timeRange ||
        !this.timeRangeCount ||
        !this.amount ||
        !this.selectedProducts.length
      ) {
        toast.warning(`Пожалуйста, проверьте все поля формы.`);
        return false;
      }

      return true;
    },

    updateSubscriptionRequest() {
      const result = this.validateForm();
      console.log(result);
      if (result) {
        this.loading = true;
        this.updateSubscription({
          name: this.subscription.name,
          timeRange: this.timeRange,
          timeRangeCount: this.timeRangeCount,
          amount: this.amount,
          products: this.selectedProducts,
        })
          .finally(() => {
            this.loading = false;
          })
          .then(() => {
            toast.success("Параметры подписки успешно обновлены.");
          })
          .catch((error) => {
            console.error(error);
            toast.error("Произошла ошибка.");
          });
      }
    },

    handleTimeRangeInput() {
      this.timeRangeCount = null;
    },

    handleTimeRangeCountInput() {
      if (this.timeRangeCount > this.maxTimeRangeCount) {
        this.timeRangeCount = this.maxTimeRangeCount;
        toast.warning(
          `Максимально допустимое значение для выбранного диапазона — ${this.maxTimeRangeCount}`
        );
      } else if (this.timeRangeCount < 1) {
        this.timeRangeCount = 1;
        toast.warning(`Минимально допустимое значение — 1`);
      }
    },
  },
  watch: {
    subscription: {
      deep: true,
      handler() {
        if (this.subscription) {
          this.timeRange = this.subscription?.timeRange || this.subscription?.time_range;
          this.timeRangeCount = this.subscription?.timeRangeCount || this.subscription?.time_range_count;
          this.amount = this.subscription?.amount;

          const foundSubscription = this.subscriptions
            ?.find((sub) => sub.name == this.subscription.name);
          
          if (foundSubscription && foundSubscription.products) {
            this.selectedProducts = foundSubscription.products.map((product) => product?.name);
          } else {
            this.selectedProducts = [];
          }
        }
      },
    },
  },
  computed: {
    ...mapGetters(["products", "subscriptions"]),

    productsOptions() {
      if (!this.products || !Array.isArray(this.products)) {
        return [];
      }
      return this.products.map((product) => ({
        value: product.name,
        label: this.getProductAlias(product.name),
      }));
    },

    timeRangePlaceholder() {
      return `Сколько ${this.timeRangeRule} нужно? (мин: 1 макс: ${this.maxTimeRangeCount}) `;
    },

    timeRangeRule() {
      const count = this.timeRangeCount;
      const pluralize = (forms) => {
        const n = Math.abs(count) % 100;
        const n1 = n % 10;
        if (n > 10 && n < 20) return forms[2];
        if (n1 > 1 && n1 < 5) return forms[1];
        if (n1 === 1) return forms[0];
        return forms[2];
      };

      switch (this.timeRange) {
        case "HOUR":
          return pluralize(["час", "часа", "часов"]);
        case "DAY":
          return pluralize(["день", "дня", "дней"]);
        case "MONTH":
          return pluralize(["месяц", "месяца", "месяцев"]);
        case "YEAR":
          return pluralize(["год", "года", "лет"]);
        default:
          return "единиц";
      }
    },

    maxTimeRangeCount() {
      switch (this.timeRange) {
        case "HOUR":
          return 24;
        case "DAY":
          return 30;
        case "MONTH":
          return 12;
        case "YEAR":
          return 5;
        default:
          return 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/_shared.scss";

.body {
  width: 500px;
  background: #000;
  padding: 20px;
  border-radius: 9px;
  border: 1px solid #0b0b0b;
  color: white;

  .header {
    margin-bottom: 20px;
  }

  .form-item {
    margin-bottom: 10px;

    .title {
      color: $dark-gray;
      margin-bottom: 5px;
    }

    .subtitle {
      color: $dark-gray;
      margin-bottom: 5px;
      font-size: 14px;
    }
  }

  .actions {
    display: flex;
    justify-content: space-between;
  }
}
</style>
